import { useState } from 'react';


function useInput(initial = '') {
  const [value, setValue] = useState(initial);

  function onChange(event) {
    if (event.target.value.length > 4) {
      return;
    }
    setValue(event.target.value.replace(/\D/, ''));
  }

  function resetValue() {
    setValue(initial);
  }

  return [value, onChange, resetValue];
}

export default useInput;
